export default {
  title: 'Kassa',
};
